import {
  Stack,
  IconButton,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  Typography,
  Modal,
} from "@mui/material";
import Page from "components/Layout/Page/Page";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useFormik } from "formik";
import * as Yup from "yup";
import { maskCpf, maskPhoneNumber, validateCpfCnpj } from "utils/Masks/Masks";
import ClientAvatarImage from "assets/client-avatar.png";
import { useState } from "react";
import ConsigazApi from "api/ConsigazApi";
import ClienteService from "services/cliente";
import { useEffect } from "react";
import { AuthService } from "context/AuthContext/AuthContext";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import { IconPerson } from "components/Icons/IconPerson";
import { toast } from "react-toastify";
import { LinkUnitsModal } from "./LinkUnitsModal";

export default function NewCpfAccess({ onSuccess, onBack, editUser }) {
  const router = useHistory();
  const history = useHistory();
  const [cpf, setCpf] = useState("");
  const [isCpfValid, setIsCpfValid] = useState(false);
  const [phone, setPhone] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenLinkUnits, setIsOpenLinkUnits] = useState(false);

  const [originalData, setOriginalData] = useState(null);

  const isEdit = Boolean(editUser);

  useEffect(() => {
    if (editUser) {
      const maskedCpf = maskCpf(editUser.CPF);
      setIsCpfValid(validateCpfCnpj(maskedCpf));
      setCpf(maskedCpf);
      formik.setFieldValue("name", editUser.nome);
      const value = maskPhoneNumber(editUser.telefone);
      setPhone(value);
      formik.setFieldValue("email", editUser.email);
      formik.setFieldValue("confirmEmail", editUser.email);

      setOriginalData({
        name: editUser.nome,
        email: editUser.email,
        phone: maskPhoneNumber(editUser.telefone),
      });
    }
  }, [editUser]);

  const localEntrega = ClienteService.localEntrega;
  const { ClienteEntrRetorno } = localEntrega;

  const validationRegisterIndustrialSchema = Yup.object({
    name: Yup.string().required("Nome é obrigatório"),
    // phone: Yup.string().required("Telefone é obrigatório"),
    email: Yup.string().email("Email inválido").required("Email é obrigatório"),
    confirmEmail: Yup.string()
      .required("Confirmação de email é obrigatória")
      .oneOf([Yup.ref("email")], "Os emails não coincidem"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      //   phone: "",
      email: "",
      confirmEmail: "",
    },
    validationSchema: validationRegisterIndustrialSchema,
    onSubmit: () => {
      if (!isCpfValid) {
        return toast.error("CPF inválido");
      }

      if (isEdit) {
        const currentUnitCodes =
          editUser?.DadosUsuarioComumLocais?.map((l) => l["Local-entrega"]) ??
          [];
        handleSubmit(currentUnitCodes);
        return;
      }

      setIsOpenLinkUnits(true);
    },
  });

  async function handleLinkUnits(localEntregaCodes) {
    await ConsigazApi.cadastraUsuarioComum(
      {
        "cpf-adm": AuthService.getUserCpfLocalStorage(),
        CNPJ: localEntrega.CPFCNPJ,
        CPF: cpf.replace(/\D/g, ""),
        DadosUsuarioComumLocais: localEntregaCodes.map((codEntrega) => ({
          CPF: cpf.replace(/\D/g, ""),
          "cod-entrega": codEntrega,
        })),
      },
      false,
      localEntregaCodes
    )
      .then((data) => {
        return true;
      })
      .catch((e) => {
        e && toast.error(e);
      });
  }

  async function handleSubmit(localEntregaCodes) {
    setIsLoading(true);
    await ConsigazApi.cadastraUsuarioComum(
      {
        "cpf-adm": AuthService.getUserCpfLocalStorage(),
        CNPJ: localEntrega.CPFCNPJ,
        CPF: cpf.replace(/\D/g, ""),
        nome: formik.values.name,
        email: formik.values.email,
        telefone: phone.replace(/\D/g, ""),
        "enviar-senha": isEdit ? "no" : "yes",
        "status-acesso": "Liberado",
        DadosUsuarioComumLocais: localEntregaCodes.map((codEntrega) => ({
          "cpf-adm": AuthService.getUserCpfLocalStorage(),
          CNPJ: localEntrega.CPFCNPJ,
          CPF: cpf.replace(/\D/g, ""),
        })),
      },
      isEdit
    )
      .then((data) => {
        if (data.retorno?.[0]?.situacao == "OK") {
          if (isEdit) {
            setIsOpenSuccess(true);
          } else {
            handleLinkUnits(localEntregaCodes).then(() =>
              setIsOpenSuccess(true)
            );
          }
        }
      })
      .catch((e) => {
        e && toast.error(e);
      })
      .finally(() => setIsLoading(false));
  }

  function handleConfirmUnits(selectedLocalEntregaCodes) {
    setIsOpenLinkUnits(false);
    handleSubmit(selectedLocalEntregaCodes);
  }

  const hasChanges =
    !originalData ||
    formik.values.name !== originalData.name ||
    formik.values.email !== originalData.email ||
    phone !== originalData.phone;

  return (
    <Page>
      <Stack
        justifyContent={"center"}
        alignItems="center"
        height="100vh"
        direction={"row"}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: 50,
            left: 70,
          }}
          onClick={onBack}
        >
          <ArrowBackIcon
            sx={{
              color: "#fff",
              fontSize: "31px",
            }}
          />
        </IconButton>
        <Stack
          border={"1px solid #fff"}
          padding={"32px 24px"}
          borderRadius={"8px"}
          direction={"row"}
          width={"930px"}
          gap={"40px"}
          mb={12}
        >
          <Stack justifyContent={"center"} alignItems={"center"} width={"30%"}>
            <Typography fontSize={"24px"} fontWeight={700} color="#fff">
              {isEdit ? "Editar usuário" : "Novo CPF"}
            </Typography>
            <Typography
              fontSize={"12px"}
              fontWeight={400}
              color="#fff"
              mb={"24px"}
              lineHeight={"100%"}
              mt={"8px"}
            >
              {isEdit
                ? "Você poderá editar todos os dados do usuário com exceção do CPF."
                : "Informe, ao lado, os dados pessoais para do colaborador para acessar o portal Consigaz."}
            </Typography>
            <img
              src={ClientAvatarImage}
              style={{
                height: "206px",
                width: "154px",
              }}
            />
          </Stack>
          <Stack width={"80%"} mt={"20px"}>
            <TextField
              variant="standard"
              placeholder="Nome"
              color="secondary"
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  color: "#2CABF9",
                },
                "& input::placeholder": {
                  color: "gray",
                },
              }}
              {...formik.getFieldProps("name")}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            <Stack direction={"row"} gap={"24px"} mt={"43px"}>
              <TextField
                variant="standard"
                color="secondary"
                value={cpf}
                fullWidth
                disabled={isEdit}
                onChange={(e) => {
                  const maskedCpf = maskCpf(e.target.value);
                  setIsCpfValid(validateCpfCnpj(maskedCpf));
                  setCpf(maskedCpf);
                }}
                placeholder="CPF"
                sx={{
                  "& input": {
                    color: "gray",
                  },
                  "& .MuiInputBase-root.Mui-disabled:before": {
                    borderBottomStyle: "solid",
                  },
                }}
              />
              <TextField
                placeholder="Telefone"
                variant="standard"
                color="secondary"
                fullWidth
                value={phone}
                onChange={(e) => {
                  const value = maskPhoneNumber(e.target.value);
                  setPhone(value);
                }}
                sx={{}}
              />
            </Stack>

            <Stack direction={"row"} gap={"24px"} mt={"43px"}>
              <TextField
                variant="standard"
                placeholder="Email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("email")}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                fullWidth
              />
              <TextField
                variant="standard"
                placeholder="Confirmar email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("confirmEmail")}
                error={
                  formik.touched.confirmEmail &&
                  Boolean(formik.errors.confirmEmail)
                }
                helperText={
                  formik.touched.confirmEmail && formik.errors.confirmEmail
                }
                fullWidth
              />
            </Stack>
            <Stack direction={"row"} gap={"20px"} mt={"40px"}></Stack>
            <Button
              disabled={isEdit && !hasChanges}
              variant="contained"
              color="secondary"
              sx={{
                color: "#fff",
                height: "45px",
                borderRadius: "36px",
                p: "10px",
              }}
              fullWidth
              onClick={formik.handleSubmit}
              loading={isLoading}
            >
              {isEdit ? "Salvar edição" : "Avançar"}
            </Button>
            <Typography sx={{ fontSize: "12px", color: "#fff", mt: "40px" }}>
              O Colaborador receberá um e-mail com as instruções de como ativar
              a senha de acesso para poder realizar o login no portal Consigaz.
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <LinkUnitsModal
        open={isOpenLinkUnits}
        onClose={() => setIsOpenLinkUnits(false)}
        addresses={ClienteEntrRetorno}
        onConfirm={handleConfirmUnits}
      />
      <Modal
        open={isOpenSuccess}
        onClose={() => setIsOpenSuccess(false)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"450px"}
          maxWidth={"450px"}
          style={{
            width: "auto",
            paddingBottom: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          borderRadius={"8px"}
          px={"24px"}
        >
          <Stack p={"32px"}>
            <Typography
              fontSize={"24px"}
              fontWeight={600}
              color="#2CABF9"
              textAlign={"center"}
              lineHeight={"100%"}
            >
              {isEdit
                ? "Dados editados com sucesso!"
                : "Acesso criado com sucesso!"}
            </Typography>
            <Typography
              fontSize={"14px"}
              fontWeight={500}
              color="#03172F"
              align="justify"
              lineHeight={"100%"}
              marginTop={"28px"}
              maxWidth={"386px"}
              textAlign={"center"}
            >
              {isEdit
                ? "Os dados editados foram salvos com sucesso."
                : "O CPF informado terá acesso a essa conta industrial assim que ativar a senha. Você poderá desabilitar seus acesso a qualquer momento na aba “Cadastrar CPF de acesso”"}
            </Typography>
          </Stack>
          <Stack
            maxWidth={"386px"}
            sx={{
              width: "100%",
              border: `solid 2px #053462`,
              borderRadius: "8px",
              padding: "24px",
              flexDirection: "row",
              gap: "24px",
              alignItems: "center",
            }}
          >
            <IconPerson />
            <Stack gap={"12px"}>
              {!isEdit && (
                <Typography
                  fontWeight={"600"}
                  fontSize={"14px"}
                  sx={{ color: "#636363" }}
                >
                  {cpf}
                </Typography>
              )}
              <Typography
                fontWeight={"600"}
                fontSize={"18px"}
                sx={{ color: "#053462" }}
              >
                {formik.values.name}
              </Typography>
              {isEdit && (
                <Typography
                  fontWeight={"600"}
                  fontSize={"14px"}
                  sx={{ color: "#636363" }}
                >
                  {formik.values.email}
                </Typography>
              )}
              {isEdit && (
                <Typography
                  fontWeight={"600"}
                  fontSize={"14px"}
                  sx={{ color: "#636363" }}
                >
                  {phone}
                </Typography>
              )}
            </Stack>
          </Stack>
          <Stack alignItems={"flex-end"} width={"100%"} mt={"20px"}>
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "18px",
              }}
              onClick={() => {
                onSuccess();
              }}
            >
              OK
            </Button>
          </Stack>
        </ContentModal>
      </Modal>
    </Page>
  );
}
